"use strict";
require('./teal');
import Dice from './dice';

export default function RollDice(canvas, dices, color) {
    var rollResult = '';
    canvas.style.width = window.innerWidth - 1 + 'px';
    canvas.style.height = window.innerHeight - 1 + 'px';
    // canvas.style.background = '#4CBB17';

    let dicesValues = [];
    let types = [];
    let diceType = ''
    dices.forEach((dice) => {
        dicesValues.push(dice.value);
        types.push(dice.type);
    })

    diceType = types.join(' + ');

    const dice = new Dice(color);

    var box = new dice.dice_box(canvas, { w: 500, h: 300 });
    box.animate_selector = false;

    function refresh() {
        canvas.style.width = window.innerWidth - 1 + 'px';
        canvas.style.height = window.innerHeight - 1 + 'px';
        box.reinit(canvas, { w: 500, h: 300 });
    }

    $t.bind(window, 'resize', refresh);

    function before_roll(vectors, notation, callback) {
        callback(dicesValues);
    }

    function notation_getter() {
        return dice.parse_notation(diceType);
    }

    function after_roll(notation, result) {
        var res = result.join(' ');
        if (notation.constant) {
            if (notation.constant > 0) res += ' +' + notation.constant;
            else res += ' -' + Math.abs(notation.constant);
        }
        if (result.length > 1) res += ' = ' +
                (result.reduce(function(s, a) { return s + a; }) + notation.constant);
        rollResult = res;
    }

    this.roll = function () {
        box.start_throw(notation_getter, before_roll, after_roll);
    }

    this.getRollResult = function () {
        return rollResult;
    }

    this.unbindEvents = function () {
        window.removeEventListener('resize', refresh);
    }
}
